import React from 'react';
import PropTypes from 'prop-types';
import RelayRouterContext from './RelayRouterContext';

export default class LazyLoader extends React.Component {
	static propTypes = {
		children: PropTypes.any,
		location: PropTypes.object.isRequired,
        routes: PropTypes.array.isRequired,
    };

	constructor(props) {
		super(props);

		this.params = this.getRouteParams(props);

		this.state = {
			lazy: Boolean(this.params.lazy),
			loaded: !Boolean(this.params.lazy)
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.location === this.props.location) {
			return;
		}

		this.params = this.getRouteParams(nextProps);

		this.setState({
			lazy: Boolean(this.params.lazy),
			loaded: !Boolean(this.params.lazy)
		});
	}

	getRouteParams(props) {
		return props.routes[props.routes.length - 1];
	}

	render() {
		if (this.state.loaded) {
			let props = this.props;

			if (this.state.lazy) {
				props.routes[props.routes.length - 1].component = this.module;

				props.components[props.components.length - 1] = props.routes[props.routes.length - 1].component;

				delete props.routes[props.routes.length - 1].lazy;
			}

			return React.createElement(
				RelayRouterContext,
				props,
				this.props.children
			);
		}

		this.params.component().then((data) => {
			this.module = data.default;

			this.setState({
				loaded: true
			});
		}).catch(() => {});

		return this.params.render();
	}
}
